export default __webpack_public_path__ + "static/media/low.d12c806a.png";